import { PageHeader } from "../components/PageHeader";
import { useContent } from "../context/ContentContext";
import { ShieldCheck, Siren, HeartHandshake } from "lucide-react";

const MEDIC_IMG = "https://images.unsplash.com/photo-1579037005241-a79202c7e9fd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxlbWVyZ2VuY3klMjByZXNwb25zZSUyMG1lZGljYWx8ZW58MHx8fHwxNzgzNjk2NDczfDA&ixlib=rb-4.1.0&q=85";

const bidang = [
  {
    id: "pencegahan",
    icon: ShieldCheck,
    title: "Pencegahan dan Kesiapsiagaan",
    color: "text-emerald-500",
    contentKey: "bidang_pencegahan",
    items: [
      "Upaya pengurangan risiko bencana (PRB) berbasis komunitas",
      "Penyusunan peta risiko dan peta rawan bencana daerah",
      "Panduan kesiapsiagaan untuk masyarakat, sekolah, dan desa tangguh bencana",
      "Pelatihan, sosialisasi, dan simulasi penanggulangan bencana rutin",
    ],
  },
  {
    id: "kedaruratan",
    icon: Siren,
    title: "Penanganan Kedaruratan",
    color: "text-red-500",
    contentKey: "bidang_kedaruratan",
    items: [
      "Mekanisme tanggap darurat cepat dengan Tim Reaksi Cepat (TRC)",
      "Prosedur evakuasi dan penetapan jalur evakuasi tiap kecamatan",
      "Ketersediaan posko siaga, logistik, dan peralatan penanggulangan",
      "Sistem peringatan dini terintegrasi dengan BMKG dan BNPB",
    ],
  },
  {
    id: "rehabilitasi",
    icon: HeartHandshake,
    title: "Rehabilitasi dan Rekonstruksi",
    color: "text-orange-500",
    contentKey: "bidang_rehabilitasi",
    items: [
      "Rencana pemulihan pasca bencana (jitupasna & R3P)",
      "Program perbaikan sarana dan prasarana yang rusak akibat bencana",
      "Penyaluran bantuan bagi korban bencana secara transparan",
      "Laporan pelaksanaan pemulihan yang dapat diakses publik",
    ],
  },
];

const DEFAULT_TRC = "TRC BPBD Kayong Utara siap dikerahkan dalam waktu singkat untuk melakukan kaji cepat kejadian bencana, penyelamatan dan evakuasi korban, serta pemenuhan kebutuhan dasar pengungsi. Hubungi Call Center 112 untuk aktivasi tim.";

export default function Bidang() {
  const { c } = useContent();
  const getItems = (b) => {
    const v = c(b.contentKey, "");
    return v ? v.split("\n").map((x) => x.trim()).filter(Boolean) : b.items;
  };
  return (
    <div data-testid="bidang-page">
      <PageHeader title="Bidang Penanggulangan Bencana" subtitle="Tiga pilar utama penyelenggaraan penanggulangan bencana: prabencana, tanggap darurat, dan pascabencana" />
      <section className="max-w-7xl mx-auto px-4 py-16 space-y-8">
        {bidang.map((b, i) => (
          <div key={b.id} id={b.id} className="hover-lift grid lg:grid-cols-3 border border-slate-200 rounded-xl overflow-hidden bg-white" data-testid={`bidang-${b.id}`}>
            <div className="p-8 bg-slate-950 text-white">
              <b.icon className={`${b.color} mb-4`} size={32} />
              <p className="font-mono text-xs text-slate-500 mb-2">0{i + 1}</p>
              <h2 className="font-heading text-lg md:text-2xl font-bold">{b.title}</h2>
            </div>
            <div className="lg:col-span-2 p-8">
              <ul className="grid sm:grid-cols-2 gap-4">
                {getItems(b).map((item) => (
                  <li key={item} className="border border-slate-200 rounded-xl p-4 text-sm text-slate-600 hover:border-orange-400 transition-colors">
                    {item}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        ))}
      </section>
      <section className="bg-slate-100 border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-16 grid lg:grid-cols-2 gap-10 items-center">
          <img src={MEDIC_IMG} alt="Respon darurat medis" className="rounded-xl border border-slate-200 h-72 w-full object-cover" />
          <div>
            <p className="section-label text-orange-600 mb-2">Siaga 24 Jam</p>
            <h2 className="font-heading text-lg font-bold text-slate-900 mb-4">Tim Reaksi Cepat (TRC)</h2>
            <p className="text-slate-600 text-sm md:text-base leading-relaxed whitespace-pre-line" data-testid="bidang-trc">
              {c("bidang_trc", DEFAULT_TRC)}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
